import React from "react";

const normalizeValue = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  if (Array.isArray(value)) return value.length ? value.join(", ") : "—";
  if (typeof value === "object") return "—";
  return String(value);
};

export default function KeyValueTable({ data, title }) {
  if (!data || typeof data !== "object") {
    return <div className="text-xs text-slate-500">No data available.</div>;
  }
  const entries = Object.entries(data);
  if (entries.length === 0) {
    return <div className="text-xs text-slate-500">No data available.</div>;
  }
  return (
    <div className="card p-5">
      {title && (
        <p className="text-sm font-semibold text-slate-900">{title}</p>
      )}
      <div className="mt-3 divide-y divide-slate-100">
        {entries.map(([key, value]) => (
          <div key={key} className="flex flex-wrap items-center justify-between gap-3 py-2">
            <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">
              {key}
            </span>
            <span className="text-sm text-slate-700">
              {typeof value === "object" && value !== null
                ? JSON.stringify(value)
                : normalizeValue(value)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
